export const environment = {
  production: false,
  name: "Trail Fusion - Developer",
  verificationRedirectUrl: "https://dev-parent-portal.trailfusion.net/sign-in",
  baseUrl: "https://dev-parent-portal.trailfusion.net",
  apiUrl: "https://us-central1-dev-parent-portal.cloudfunctions.net/api/parent",
  apiUrlNewCall:
    "https://us-central1-dev-parent-portal.cloudfunctions.net/api/",
  apiUrlCache:
    "https://us-central1-dev-parent-portal.cloudfunctions.net/api/cache",
  apiUrlMail:
    "https://us-central1-dev-parent-portal.cloudfunctions.net/api/mail",
  stripePublishableKey:
    "pk_test_51RwRdTJzahxkiJ95FMEM60DC7HgDpIchE4Mw4qigxKqFkhVEEziyfCM050qU0xs3NCasVCLuMbaDRamBeLBjY2lq00ttiKyDUm",
  adminPortalUrl: "https://dev-admin-portal.trailfusion.net/sign-in",
  authorizeNet: {
    apiLoginId: "52Fb7w4XNa",
    clientKey:
      "57fUvnLK4V9qZKganv238c2rZ2rQ26RvVEgx6g7K4bk6tYPFhXeY822wLFXe2zYM",
    environment: "sandbox",
  },
  firebase: {
    apiKey: "AIzaSyC4RLl0RhgYXOtVJ0WJxeiHJYrckL8WwTQ",
    authDomain: "dev-parent-portal.firebaseapp.com",
    projectId: "dev-parent-portal",
    storageBucket: "dev-parent-portal.firebasestorage.app",
    messagingSenderId: "1049676702592",
    appId: "1:1049676702592:web:a3da05e829afc9406f5765",
    measurementId: "G-NNLHN9LQK9",
  },
  ipifyUrl: "https://api.ipify.org/?format=json",
  ipinfoUrl: "https://ipinfo.io/",
  ipinfoToken: "?token=abe7cb4c38b788",
  getClientIPAddressByIpify: "getClientIPAddressByIpify",
};
